import { gql } from '@apollo/client';
import { GqlSeason, GqlSeasonFragment } from '../fragments/season';

export interface Variables {
  seasonId: string;
}

export interface Data {
  showSeason: GqlSeason;
}

export const QUERY = gql`
  query ShowSeason($seasonId: Int!) {
    showSeason(seasonId: $seasonId) {
      ...SeasonFields
      program {
        id
        name
        sportId
      }
      teams {
        id
        name
        divisionId
      }
      divisions {
        id
        name
      }
      registrationForms {
        id
        name
        isRetired
      }
    }
  }
  ${GqlSeasonFragment}
`;
